// extracted by mini-css-extract-plugin
export var link = "Footer-module--link--5d828";
export var linkbutton = "Footer-module--linkbutton--40e22";